<template>
  <div class="home" :class="[colorTheme]">
    <v-app id="inspire">
      <v-app-bar app light fixed class="bg-orange">
        <i class="material-icons-outlined" style="font-size:30px;" @click="cancel">clear</i>
        <!-- 套餐選擇 -->
        <v-toolbar-title>{{currentSet['name_'+locale]}} {{i18n.setTags}} </v-toolbar-title>
      </v-app-bar>
      <SetSelection />
    </v-app>
  </div>
</template>

<script>
import SetSelection from "@/components/SetSelection.vue";
import localeMixin from '@/mixins/localeMixin.js'

export default {
  mixins: [localeMixin],
  components: {
    SetSelection,
  },
  created: function () {
    if (typeof this.$store.state.currentSet.setItems === "undefined") {
      this.$router.push({ path: "/TakeAwayMenu" });
    } else {
    }

  },
  mounted: function () {

  },
  data: () => ({
    drawer: null,
  }),
  computed: {
    currentSet: function () {
      return this.$store.state.currentSet;
    },


    colorTheme: function () {
      return this.$store.state.shop.color_theme;
    },
    locale: function () {
      return this.$store.state.locale;
    },
    i18n:function(){
      return this.$store.state[this.$store.state.locale];
    },
  },
  methods: {
    cancel: function () {
      this.$router.go(-1);
    },
  },
};
</script>
